<div class="form-content-item">
  <div class="validation-header">
    <h2 class="validation-title">{{ 'validation_title' | translate }}</h2>
    <span class="validation-count" *ngIf="!loading && pendingRequests.length > 0">{{ 'validation_pending_count' | translate: { count: pendingRequests.length } }}</span>
  </div>

  <div *ngIf="loading" class="validation-empty">{{ 'validation_loading' | translate }}</div>
  <div *ngIf="!loading && pendingRequests.length === 0" class="validation-empty">{{ 'validation_empty_pending' | translate }}</div>

  <div *ngIf="!loading && pendingRequests.length > 0" class="validation-table">
    <div class="vt-head">
      <span class="vt-col vt-col-name">{{ 'validation_col_name' | translate }}</span>
      <span class="vt-col vt-col-profile">{{ 'validation_col_profile' | translate }}</span>
      <span class="vt-col vt-col-org">{{ 'validation_col_organisation' | translate }}</span>
      <span class="vt-col vt-col-email">{{ 'validation_col_email' | translate }}</span>
      <span class="vt-col vt-col-date">{{ 'validation_col_date' | translate }}</span>
      <span class="vt-col vt-col-action"></span>
    </div>

    <div class="vt-row" *ngFor="let request of pendingRequests">
      <span class="vt-col vt-col-name">
        <span class="vt-name">{{ request.prenom }} {{ request.nom }}</span>
        <span class="vt-fonction" *ngIf="request.fonction">{{ request.fonction }}</span>
      </span>
      <span class="vt-col vt-col-profile">
        <span class="profile-badge" [ngClass]="'profile-' + request.profileType"> <span class="profile-dot"></span>{{ profileLabel(request.profileType) }} </span>
      </span>
      <span class="vt-col vt-col-org">
        {{ request.organisation }}
        <span class="new-org-tag" *ngIf="!request.memberId">{{ 'validation_new_organisation' | translate }}</span>
      </span>
      <span class="vt-col vt-col-email">{{ request.email }}</span>
      <span class="vt-col vt-col-date">{{ request.creationDate | localizedDate: 'shortDate' }}</span>
      <span class="vt-col vt-col-action">
        <button type="button" class="vt-eye" (click)="openDetail(request)" [title]="'validation_action_view' | translate" [attr.aria-label]="'validation_action_view' | translate">
          <mat-icon>visibility</mat-icon>
        </button>
      </span>
    </div>
  </div>
</div>
